import { useHubCheckoutContext } from "hub/src/pages/checkout/context/HubCheckoutContext";
import { PaymentType } from "hub/src/pages/checkout/payment-form/HubCheckoutPaymentFormHelpers";

export const HubCheckoutPaymentOptions = () => {
  const { paymentType, setPaymentType, hubPaymentTypes } =
    useHubCheckoutContext();
  return (
    <div>
      {hubPaymentTypes && hubPaymentTypes.check && (
        <div className="flex justify-center">
          <button
            type="button"
            className={`mx-2 w-fit whitespace-nowrap ${
              paymentType == PaymentType.CARD
                ? "button-regular-general-filled"
                : "text-neutral-mid-600 text-base"
            }`}
            onClick={() => setPaymentType(PaymentType.CARD)}
          >
            Card
          </button>
          <button
            type="button"
            className={`mx-2 w-fit whitespace-nowrap ${
              paymentType == PaymentType.CHECK
                ? "button-regular-general-filled"
                : "text-neutral-mid-600 text-base"
            }`}
            onClick={() => setPaymentType(PaymentType.CHECK)}
          >
            Check
          </button>
        </div>
      )}
    </div>
  );
};
